export default "__VITE_ASSET__lWsyklK2__"